export const CRITEO_URL = '*.criteo.com';
export const CRITEO_NET = '*.criteo.net';
